import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=44f12a33&scoped=true&"
import script from "./FaqComponent.vue?vue&type=script&lang=js&"
export * from "./FaqComponent.vue?vue&type=script&lang=js&"
import style0 from "./FaqComponent.vue?vue&type=style&index=0&id=44f12a33&prod&scoped=true&lang=css&"
import style1 from "./FaqComponent.vue?vue&type=style&index=1&id=44f12a33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f12a33",
  null
  
)

export default component.exports